import React from 'react';

import { olderDeclarationsTypes } from './actions'

const initialState = {
    isFetching: false,
}

const makeDeclarationsByContractNumber = (olderDeclarations) => {
    let declarationsByContractNumber = {}

    if (olderDeclarations === null) {
        return {}
    }

    for (var declaration of olderDeclarations.Customer.DeclarationReportList.DeclarationReport) {
        if(declarationsByContractNumber.hasOwnProperty(declaration.CustAccount)) {
            if (declarationsByContractNumber[declaration.CustAccount].hasOwnProperty(declaration.ContractId)) {
                declarationsByContractNumber[declaration.CustAccount][declaration.ContractId].push(declaration)
            }
            else {
                declarationsByContractNumber[declaration.CustAccount][declaration.ContractId] = [declaration]
            }
        } else {
            let decl = {}
            decl[declaration.ContractId] = [declaration]
            declarationsByContractNumber[declaration.CustAccount] = decl
        }       
    }
    return declarationsByContractNumber
}

export function olderDeclarations(state = initialState, action) {

    switch(action.type) {

        case olderDeclarationsTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case olderDeclarationsTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.declarationsByContractNumber = makeDeclarationsByContractNumber(action.data)

            return state


        default:
            return state
    }
}